'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactBootstrap = require('react-bootstrap');

var ReactBootstrap = _interopRequireWildcard(_reactBootstrap);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
 * Food Serve Table
 */
var FoodServeTable = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(FoodServeTable, _Component);

  function FoodServeTable() {
    (0, _classCallCheck3.default)(this, FoodServeTable);
    return (0, _possibleConstructorReturn3.default)(this, (FoodServeTable.__proto__ || (0, _getPrototypeOf2.default)(FoodServeTable)).apply(this, arguments));
  }

  (0, _createClass3.default)(FoodServeTable, [{
    key: 'render',
    value: function render() {
      var styles = require('../Modules.scss');
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          ReactBootstrap.Col,
          { md: 12 },
          _react2.default.createElement(
            'strong',
            { className: styles.orangeText },
            'The number of serves your child needs will depend on his or her age'
          ),
          _react2.default.createElement(
            ReactBootstrap.Table,
            { bordered: true, responsive: true },
            _react2.default.createElement(
              'thead',
              null,
              _react2.default.createElement(
                'tr',
                null,
                _react2.default.createElement('th', null),
                _react2.default.createElement(
                  'th',
                  null,
                  '2 - 3 years'
                ),
                _react2.default.createElement(
                  'th',
                  null,
                  '4 - 8 years'
                ),
                _react2.default.createElement(
                  'th',
                  null,
                  '9 - 11 years'
                ),
                _react2.default.createElement(
                  'th',
                  null,
                  '12 - 13 years'
                )
              )
            ),
            _react2.default.createElement(
              'tbody',
              null,
              _react2.default.createElement(
                'tr',
                null,
                _react2.default.createElement(
                  'td',
                  null,
                  this.props.foodtype
                ),
                _react2.default.createElement(
                  'td',
                  null,
                  this.props.twoyear
                ),
                _react2.default.createElement(
                  'td',
                  null,
                  'Boys: ',
                  this.props.fouryearboy,
                  _react2.default.createElement('br', null),
                  'Girls: ',
                  this.props.fouryeargirl
                ),
                _react2.default.createElement(
                  'td',
                  null,
                  'Boys: ',
                  this.props.nineyearboy,
                  _react2.default.createElement('br', null),
                  'Girls: ',
                  this.props.nineyeargirl
                ),
                _react2.default.createElement(
                  'td',
                  null,
                  'Boys: ',
                  this.props.twelveyearboy,
                  _react2.default.createElement('br', null),
                  'Girls: ',
                  this.props.twelveyeargirl
                )
              )
            )
          )
        )
      );
    }
  }]);
  return FoodServeTable;
}(_react.Component), _class.propTypes = {
  foodtitle: _propTypes2.default.string,
  foodtype: _propTypes2.default.string,
  twoyear: _propTypes2.default.string,
  fouryearboy: _propTypes2.default.string,
  fouryeargirl: _propTypes2.default.string,
  nineyearboy: _propTypes2.default.string,
  nineyeargirl: _propTypes2.default.string,
  twelveyearboy: _propTypes2.default.string,
  twelveyeargirl: _propTypes2.default.string
}, _temp);
exports.default = FoodServeTable;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/ServeInformation/FoodTable.js
// module id = 1264
// module chunks = 0